import { MODELS, isModelSelectable, type ModelId } from "@/lib/models";

interface Props {
  value: ModelId;
  onChange: (id: ModelId) => void;
  disabled?: boolean;
}

export function ModelPicker({ value, onChange, disabled }: Props) {
  return (
    <select
      data-testid="model-picker"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as ModelId)}
      className="rounded-md border border-input bg-background px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50"
    >
      {MODELS.map((m) => {
        const selectable = isModelSelectable(m.id);
        return (
          <option key={m.id} value={m.id} disabled={!selectable}>
            {m.provider} — {m.name}
            {selectable ? "" : " (unavailable in demo)"}
          </option>
        );
      })}
    </select>
  );
}
